
import { defineComponent, onMounted, PropType, ref, computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { DateKindLabel } from '@/views/dashboard/service/_enum/date-kind'
import { PayType, PayTypeLabel } from '@/views/dashboard/service/_enum/pay-type'
import { ElMessageBox } from 'element-plus'
import ServiceEnum from '@/views/dashboard/service/_components/service-enum/service-enum.vue'
import { BrandConfig, useBrandCustomStore } from '@/services/brand-custom.service'

interface BaseInfo {
  /** 服务期限类型 1-日、2-月、3-季、4-年 */
  date_kind: number
  /** 周期数量，比如date_kind=1，cycle_count=2，表示2年 */
  cycle_count: number
  purchase_count: number // 购买终端数量
  current_price: number // 金额，单位分
  group: string
  services: string[]
}

const onlinePayIcon = require('./_images/online-pay.png')
const officePayIcon = require('./_images/office-pay.png')

export default defineComponent({
  components: { ServiceEnum },
  props: {
    baseInfo: {
      type: Object as PropType<BaseInfo>,
      default: () => ({} as any)
    }
  },

  setup (props, context) {
    const { t, locale } = useI18n()
    const checkedPayIndex = ref(0)
    const isCheckedProtocol = ref(false)

    const payTypes = computed(() => {
      void locale.value
      return [
        {
          type: PayType.online,
          icon: onlinePayIcon,
          title: PayTypeLabel[PayType.online],
          describe: t('confirmOrder.payDescribeOnline'),
          isCheck: checkedPayIndex.value === 0,
        },
        {
          type: PayType.office,
          icon: officePayIcon,
          title: PayTypeLabel[PayType.office],
          describe: t('confirmOrder.payDescribeOffice'),
          isCheck: checkedPayIndex.value === 1,
        },
      ]
    })

    function checkPayType (index: number) {
      checkedPayIndex.value = index
    }

    onMounted(() => {
      checkPayType(0)
    })

    function checkConfirm () {
      if (!isCheckedProtocol.value) {
        ElMessageBox.confirm(
          `<div>${t('confirmOrder.protocolReadPrompt')}</div><a class="cm-link-light" target="_blank" href="/privacy/dubateam-payment-terms.html">${t('confirmOrder.paymentTermsLinkText')}</a>`,
          t('subscribeDetails.dialogTip'),
          {
            confirmButtonText: t('confirmOrder.agreeProtocol'),
            dangerouslyUseHTMLString: true,
          },
        ).then(() => {
          isCheckedProtocol.value = true
          confirm()
        })
      } else {
        confirm()
      }
    }

    function confirm () {
      const payType = payTypes.value.find(v => v.isCheck)!.type
      context.emit('confirm', { payType })
    }

    return {
      brandConfig: useBrandCustomStore().brandConfig as BrandConfig,
      payTypes,
      isCheckedProtocol,
      DateKindLabel,
      checkPayType,
      /** 父组件用 */
      checkConfirm,
    }
  }
})
